import axios from 'axios';
import MockAdapter from 'axios-mock-adapter';
import { Config } from 'Constants/config_env';
import { createReqId } from 'Utility/globalMethods';
import { getAuth } from 'Components/AcgFlow/utils';

const defaultHeaders = {
	Accept: 'application/json, text/plain, */*',
	Application: Config.application,
	'cache-control': 'no-cache',
	'Content-Type': 'application/json',
	pragma: 'no-cache',
};

if(window.sessionStorage.getItem('sessionId') !== null) defaultHeaders['MT_SESSION_ID'] = window.sessionStorage.getItem('sessionId')
const defaultBody = {};

// Axios configuration
const axiosInstance = axios.create({
	withCredentials: /INTEGRATION/.test(Config.environment) || /DEVELOP/.test(Config.environment),
	baseURL: Config.api_rest_be,
	headers: {
		common: { ...defaultHeaders },
		post: { ...defaultHeaders },
	},
});

// Add a request interceptor
axiosInstance.interceptors.request.use(
	(config) => {
    if(window.sessionStorage.getItem('jwt') !== null) {
      config.headers.Authorization = `Bearer ${window.sessionStorage.getItem('jwt')}`;
      config.headers['MT_REQUEST_ID'] = createReqId();
    }
    return config;
  },
	(error) => Promise.reject(error)
);

// Add a response interceptor
axiosInstance.interceptors.response.use(
	(response) => {
		// Do something with response data
		if (response.status === 401 && !/logger/.test(location.href)) getAuth();
		return response;
	},
	(error) => {
		return error.response;
	}
);
const mockInstance = new MockAdapter(axiosInstance, { delayResponse: 1500 });

if (!ISMOCK) {
	mockInstance.onAny().passThrough();
} else {
	mockInstance.onGet(/^http:\/\/localhost:4001\/*/).passThrough();
	mockInstance.onPost(/^http:\/\/localhost:4001\/*/).passThrough();
	mockInstance.onPost(/^http:\/\/intapi.nexi.it:8443\/*/).passThrough();
}
export { defaultHeaders, defaultBody, mockInstance, axiosInstance };
